export default __webpack_public_path__ + "static/media/plant.1f00a845.png";